export class GST {
    public sgst: number;
    public cgst: number;
    public igst: number;

    constructor(sgst: number, cgst: number, igst: number) {
        this.sgst = sgst;
        this.cgst = cgst;
        this.igst = igst;
    }

    public static from(json: any): GST {
        if (!json) {
            return json;
        }
        return new GST(json.sgst, json.cgst, json.igst);
    }

    public total(): number {
        if (this.igst) {
            return this.igst;
        } else {
            return this.sgst + this.cgst;
        }
    }
}